import type { Theme as LocalTheme } from '@trinity/chat-components/types/theme';

export const primaryColorOrSentimentFallback = (theme: LocalTheme.Theme): string =>
  theme.palette.wl?.enabled ? theme.palette.wl.primary.main : theme.palette.sentiment.primary.main;
